import {Mapper} from '@s-ui/domain'

export class FromCommentAnswersResponseToVOMapper extends Mapper {
  constructor({fromRawCommentResponseToCommentEntityMapper}) {
    super()

    this._fromRawCommentResponseToCommentEntityMapper = fromRawCommentResponseToCommentEntityMapper
  }

  map = rawAnswersResponse => {
    return (rawAnswersResponse || []).map(answerData =>
      this._fromRawCommentResponseToCommentEntityMapper.map({...answerData})
    )
  }
}
